<template>
  <v-container>
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card color="success" light max-width="100%" width="400" class="px-5 py-3">
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold">Login</h1>
            </div>
          </template>
          <formulate-form @submit="login">
            <v-row class="ml-7">
              <v-col cols="12">
                <formulate-input
                  v-model="user_form.email"
                  type="email"
                  name="email"
                  label="Email"
                  placeholder="Email"
                  validation="required|email"
                  error-behavior="blur"
                />

                <formulate-input
                  v-model="user_form.password"
                  label="Password"
                  type="password"
                  name="password"
                  placeholder="Password"
                  error-behavior="blur"
                  validation="required"
                />
              </v-col>
            </v-row>
            <v-card-text class="text-center">
              <pages-btn
                large
                color
                depressed
                class="v-btn--text success--text"
                :loading="resetLoader"
                :disabled="resetLoader"
                type="submit"
              >
                Let's Go
                <template v-slot:loader>
                  <span class="custom-loader">
                    <v-icon light>mdi-cached</v-icon>
                  </span>
                </template>
              </pages-btn>
              <br />
            </v-card-text>
          </formulate-form>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
    <v-snackbar v-model="snackbar" :timeout="timeout" :color="colorValue">{{ text }}</v-snackbar>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "PagesLogin",
  components: {
    PagesBtn: () => import("./components/Btn"),
  },
  data: () => ({
    user_form: {
      email: "",
      password: "",
    },
    resetLoader: false,

    snackbar: false,
    text: "",
    timeout: 5000,
    colorValue: "",
  }),
  mounted() {
    if (
      this.$store.state.user.isLoggedIn &&
      this.$store.state.user.role === "ADMIN"
    ) {
      this.$router.push("admin/users");
    }
  },

  methods: {
    ...mapActions(["doLogin"]),
    async login() {
      this.resetLoader = true;

      this.doLogin(this.user_form).then(
        (response) => {
          this.snackbar = true;
          this.text = "Welcome";
          this.resetLoader = false;
          if (response.data.success) {
            this.colorValue = "success";
            this.$router.push("/users");
          } else {
            this.colorValue = "error";
          }
        },
        (error) => {
          this.snackbar = true;
          this.colorValue = "red";
          this.text = error.data.message;
          this.resetLoader = false;
        }
      );
    },
  },
};
</script>
